import { render, staticRenderFns } from "./SettingsShortcut.vue?vue&type=template&id=5373be7b&scoped=true"
import script from "./SettingsShortcut.vue?vue&type=script&lang=js"
export * from "./SettingsShortcut.vue?vue&type=script&lang=js"
import style0 from "./SettingsShortcut.vue?vue&type=style&index=0&id=5373be7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5373be7b",
  null
  
)

export default component.exports